module.exports = __webpack_public_path__ + "img/img-brand-pulmotil.167e8ead.svg";